import Field from "@/components/Field";
import { FormLabel } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface TimeRangeFieldProps {
  disabled?: boolean;
}

const TimeRangeFieldComponent = ({ disabled = false }: TimeRangeFieldProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-3 space-y-2">
      <FormLabel>{t("projectSchedules.fields.hours_range")}</FormLabel>
      <div className="flex flex-row gap-4 flex-1">
        <Field
          name="suggested_start_time"
          wrapperClassName="flex-1"
          className="space-y-2"
          render={({ field }) => (
            <Input
              type="time"
              className="w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              disabled={disabled}
              {...field}
            />
          )}
        />
        <Field
          name="suggested_end_time"
          wrapperClassName="flex-1"
          className="space-y-2"
          render={({ field }) => (
            <Input
              type="time"
              className="w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              disabled={disabled}
              {...field}
            />
          )}
        />
      </div>
    </div>
  );
};

export const TimeRangeField = memo(TimeRangeFieldComponent);
